import { atom } from 'jotai';

export type EditLinkState = {
  pageId: string;
  title: string;
  url: string;
};

export const editLinkAtom = atom<EditLinkState | null>(null);
